// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"688c05b4","977":"282b4850"}[chunkId] + ".chunk.js";
};